import React, { useState } from 'react';
import api from '../../services/api';
import { formatApiError } from '../../utils/errorMessage';

// "History" on an account: every starting-balance change (who, when, why,
// old and new figure and date), newest first.
export const REASON_LABELS = {
  manual_edit: 'Changed on the account form',
  recalculated: 'Recalculated',
  calculated_from_transactions: 'Calculated from transactions',
  anchor_predates_bank: 'Moved to match the bank feed',
};

export const reasonLabel = (r) => REASON_LABELS[r] || String(r || '').replace(/_/g, ' ');

export default function StartingBalanceHistory({ account, format }) {
  const [rows, setRows] = useState(null);
  const [open, setOpen] = useState(false);
  const [error, setError] = useState('');
  const toggle = async () => {
    if (open) { setOpen(false); return; }
    setOpen(true);
    setError('');
    try {
      setRows((await api.get(`/accounts/${account.id}/starting-balance-changes`)).data || []);
    } catch (err) {
      setError(formatApiError(err, 'Could not load the history'));
    }
  };
  const money = (v) => (v === null || v === undefined ? '—' : format(Number(v)));
  return (
    <>
      <button type="button" onClick={toggle} className="text-gray-700 hover:text-gray-900 mr-3" title="Starting balance change history">
        History
      </button>
      {open && (
        <div role="dialog" aria-label="Starting balance history" className="fixed inset-0 z-50 flex items-center justify-center bg-black/30" onClick={() => setOpen(false)}>
          <div className="bg-white rounded-lg shadow-lg p-4 max-w-2xl w-full max-h-[80vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="flex justify-between items-center mb-3">
              <h3 className="font-semibold">Starting balance history: {account.account_name}</h3>
              <button type="button" onClick={() => setOpen(false)} className="text-gray-500">Close</button>
            </div>
            {error && <p className="text-red-600 text-sm">{error}</p>}
            {!error && rows === null && <p className="text-sm text-gray-500">Loading...</p>}
            {rows && rows.length === 0 && <p className="text-sm text-gray-500">No starting balance changes yet.</p>}
            {rows && rows.length > 0 && (
              <table className="w-full text-sm">
                <thead><tr className="text-left text-gray-500"><th>When</th><th>What</th><th>From</th><th>To</th><th>By</th></tr></thead>
                <tbody>
                  {rows.map((r) => (
                    <tr key={r.id} className="border-t">
                      <td className="py-1">{new Date(r.created_at).toLocaleString()}</td>
                      <td>{reasonLabel(r.reason)}</td>
                      <td>{money(r.old_opening_balance)} {r.old_opening_balance_date ? `as of ${r.old_opening_balance_date}` : ''}</td>
                      <td>{money(r.new_opening_balance)} as of {r.new_opening_balance_date}</td>
                      <td>{r.changed_by || '—'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      )}
    </>
  );
}
